import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AddressProofService {

  has_transaction = new BehaviorSubject(false);
  has_address_proof = new BehaviorSubject(false);
  has_nomipay_reserve = new BehaviorSubject(false);

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    })
  }
  httpOptionsFiles = {
    headers: new HttpHeaders({
      'enctype': 'multipart/form-data',
      'Accept': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache'
    })
  }

  constructor(
    private http: HttpClient,

  ) { }
  setTransaction(value: boolean) {
      this.has_transaction.next(value);
    }
    setAdressProof(value: boolean) {
      this.has_address_proof.next(value);
    }
     setNomipayReserve(value: boolean) {
      this.has_nomipay_reserve.next(value);
    }
  // Handle API errors
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.'
    );
  };

  create(image) {
    return this.http.post(environment.API_URL + '/address_proof/create', {image},this.httpOptions)
    .pipe(
      tap(data => {
        return data;
      }),
      catchError(this.handleError)
    ) 
  }

 
}
